// extracted by mini-css-extract-plugin
export var carouselControlsWrapperStyle = "carousel_controls_wrapper-module--carouselControlsWrapperStyle--VPGd9";